import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  selectedReport: '0',
};

const violationsReportSlice = createSlice({
  name: 'aag/violationsReport',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSelectedReport: (state, action: PayloadAction<string>) => {
      state.selectedReport = action.payload;
    },
  },
});

const { reducer: violationsReportReducer, actions } = violationsReportSlice;

export const violationsReportActions = actions;
export default violationsReportReducer;
